import { Link as RouterLink, LinkProps } from 'react-router-dom';

import { Link, LinkProps as ChakraLinkProps } from '@oaknorth/component-core-v2';

export type InternalTextLinkProps = Omit<ChakraLinkProps, 'as' | 'isExternal' | 'href'> &
  LinkProps &
  React.RefAttributes<HTMLAnchorElement>;

/**
 * Renders and internal link (from `react-router-dom`) with the styles of
 * a chakra `Link` (pointer cursor, underline on hover)
 *
 * Only for use for internal links where the content is text:
 * - Use `Link` from `@oaknorth/util-routing` to make other components (e.g. buttons) behave as links
 * - Use `Link` from `@oaknorth/component-core-v2` to make text links for external pages
 */
export function InternalTextLink(props: InternalTextLinkProps) {
  return <Link as={RouterLink} {...props} />;
}
